module.exports = __webpack_public_path__ + "static/media/MOMO.8b9f5080.svg";